export const ConfigFacebookPixel = async (id) => {
  let code = document.createElement("script");
  code.text =
    '!function(f,b,e,v,n,t,s)\r\n  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\r\n  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\r\n  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";\r\n  n.queue=[];t=b.createElement(e);t.async=!0;\r\n  t.src=v;s=b.getElementsByTagName(e)[0];\r\n  s.parentNode.insertBefore(t,s)}(window, document,"script",\r\n  "https://connect.facebook.net/en_US/fbevents.js");\r\n  fbq("init","' +
    id +
    '");\r\n  fbq("track", "PageView");';
  document.head.appendChild(code);

  let codenoscript = document.createElement("noscript");

  const image = document.createElement("img");

  image.setAttribute(
    "src",
    "https://www.facebook.com/tr?id=" + id + "&ev=PageView&noscript=1"
  );
  image.setAttribute("height", 1);
  image.setAttribute("width", 1);
  codenoscript.appendChild(image);

  document.head.appendChild(codenoscript);
};
